export default "__VITE_ASSET__VFeL_Qgd__"